




























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class LifetimeChanger extends Vue {
  private selectedLifetime = 3;
  private availableLifetime = [{
    value: 1,
    label: "1 year"
  }, {
    value: 2,
    label: "2 years"
  }, {
    value: 3,
    label: "3 years"
  }];

  private visible = false;

  @Prop()
  private disabled?: boolean;

  private confirm() {
    this.visible = false;
    this.$emit("changed", this.selectedLifetime);
  }
}
